import { Person } from '@/interfaces/person';
import { DriverService } from '@/services/driver/driver.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { Option } from '@/shared/select-list/select-list.component';
import { ofuscate } from '@/utils/obfuscation';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {

  @Input() controlForm: FormGroup = new FormGroup({
    id: new FormControl(0, [Validators.required, Validators.min(1)]),
    email: new FormControl('', [Validators.required]),
    mdmid: new FormControl('', [Validators.required]),
  });

  requestType: 'driver' | 'infraction';

  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
    mdmid: new FormControl(''),
  });

  backColor: BoxColors = BoxColors.WHITE;

  listPersonOptions: Option[] = [];
  loadingPersonOptions: boolean = false;
  selectedPersonData?: Person;

  constructor(
    private driverService: DriverService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

    this.requestType = <'driver' | 'infraction'>(
      this.router.url.split('/').reverse()[0]
    );

    const {
      filterText: filterText$,
    } = this.personForm.controls;

    filterText$.valueChanges
      .pipe(
        tap(() => {
          this.loadingPersonOptions = true;
        }),
        debounceTime(2000),
        switchMap((value) => this.driverService.getFilteredList(value)),
      )
      .subscribe({
        next: (options) => {
          this.listPersonOptions = options;
          this.loadingPersonOptions = false;
        },
      });

  }

  ngOnInit() {
    this.controlForm.controls.id.valueChanges.subscribe({
      next: (value) => {
        if (value === null) {
          this.selectedPersonData = undefined;
        }
      },
    });
  }

  onSearchPersonTextChange(text: string) {
    this.personForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.personForm.patchValue({ id: +id });
  }

  onSelectPerson() {
    const personId = this.personForm.controls.id.value;
    const ofuscatedData = ofuscate({ personId });
    this.router.navigate(['result', ofuscatedData], { relativeTo: this.activatedRoute });
  }

  onUnselect() {
    this.personForm.patchValue({ id: -1, filterText: '' });
    this.controlForm.controls.id.patchValue(0);
    this.controlForm.controls.email.patchValue('');
    this.controlForm.controls.mdmid.patchValue('');
    this.selectedPersonData = undefined;
    this.listPersonOptions = [];
  }

}
